import { useApplicationContext } from '../../context/ApplicationContext/ApplicationContext';
import { useAbility } from '../../users/AbilityContext';

const useCanReadSalesRepresentatives = () => {
  const ability = useAbility();
  const { isSeller } = useApplicationContext();

  const isBrandSeller = isSeller && !ability.isCustomRole();

  return ability.can('read', 'sales-representatives') && !isBrandSeller;
};

export default useCanReadSalesRepresentatives;
